import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

export default function PayrollActionBar({
  selectedCount,
  processingStatus,
  hasRestrictedSelectedEmployees,
  onValidate,
  onMarkReviewed,
  onApprove,
  onLockAndProcess,
  onGeneratePayslip,
  onBulkPayslips,
}) {
  const disabled = selectedCount === 0 || hasRestrictedSelectedEmployees;
  const busy = processingStatus?.status === 'processing';

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span className="inline-flex items-center justify-center min-w-[1.75rem] h-7 px-2 rounded-full bg-primary/10 text-primary font-semibold text-xs">
            {selectedCount}
          </span>
          <span>employees selected</span>
          {hasRestrictedSelectedEmployees && (
            <span className="text-amber-700 text-xs">· restricted employees excluded</span>
          )}
        </div>

        <div className="flex flex-wrap gap-2">
          <Button variant="outline" size="sm" disabled={disabled} onClick={onValidate} iconName="CheckCircle">
            Validate
          </Button>
          <Button variant="outline" size="sm" disabled={disabled} onClick={onMarkReviewed} iconName="Search">
            Mark Reviewed
          </Button>
          <Button variant="secondary" size="sm" disabled={disabled} onClick={onApprove} iconName="UserCheck">
            Approve
          </Button>
          <Button
            variant="default"
            size="sm"
            disabled={disabled || busy}
            onClick={onLockAndProcess}
            iconName="Lock"
            loading={busy}
          >
            Lock & Process
          </Button>
          <Button
            variant="outline"
            size="sm"
            disabled={selectedCount === 0}
            onClick={selectedCount === 1 ? onGeneratePayslip : onBulkPayslips}
            iconName="FileText"
          >
            {selectedCount === 1 ? 'Payslip' : 'Payslips'}
          </Button>
        </div>
      </div>

      {processingStatus && (
        <div className={`mt-3 px-3 py-2 rounded-lg border text-sm flex items-center gap-2 ${
          processingStatus.status === 'processing' ? 'bg-amber-50 border-amber-200 text-amber-900' :
          processingStatus.status === 'completed' ? 'bg-green-50 border-green-200 text-green-900' :
          'bg-muted border-border'
        }`}>
          <Icon
            name={processingStatus.status === 'processing' ? 'Loader2' : 'CheckCircle'}
            size={16}
            className={processingStatus.status === 'processing' ? 'animate-spin' : ''}
          />
          <span>{processingStatus.message}</span>
        </div>
      )}
    </div>
  );
}
